if (!customElements.get('accent-carousel')) {
  class AccentCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        updateOnMove: true,
        drag: false,
        perPage: 1,
        gap: 115,
        arrows: false,
        pagination: false,
        breakpoints: {
          989: {
            gap: 20,
          },
        }
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      this.slider = new Splide(this,this.options).mount();
    }
  }
  customElements.define('accent-carousel', AccentCarousel);
}
